import { Validator } from 'jsonschema';
import { validateEmail, validateUrl } from './schemaUtilities';

// Setup custom validation functions for email & url validation, this gives us more control and ensures consistent validation logic on clients and server.
Validator.prototype.customFormats['oaf-email'] = validateEmail;
Validator.prototype.customFormats['oaf-url'] = validateUrl;
export function validateJsonSchema(payload, schema, options) {
  return new Validator().validate(payload, schema, options).errors.map(error => {
    delete error.schema;
    delete error.instance;
    return {
      ...error,
      code: 'invalid'
    };
  });
}